import { Injectable } from '@angular/core';

import { RefreshTokenPayload } from '@modules/core/interfaces';
import { RefreshTokenResponseDTO } from '@paymash/local-sdk/dto/response';
import { RefreshTokenRequestDTO } from '@paymash/local-sdk/dto/request';
import { Auth } from '@models';

@Injectable({
  providedIn: 'root',
})
export class RefreshTokenMapper {
  public mapToEntity(dto: RefreshTokenResponseDTO): Auth {
    return {
      accessToken: dto.accessToken,
      refreshToken: dto.refreshToken,
    };
  }

  public mapToDTO(entity: RefreshTokenPayload): RefreshTokenRequestDTO {
    return {
      refreshToken: entity.refreshToken,
    };
  }
}
